import { filter, join, map, pipe, replace, slice, toPairs } from 'ramda';

export const withProtocol = (url: string): string => (slice(0, 2, url) === '//' ? `https:${url}` : url);

export const withoutProtocol: (url: string) => string = replace(/^https?:/, '');

export const argsFromObject = pipe<object, [string, string][], [string, string][], string[], string>(
  toPairs,
  filter(([key]) => Boolean(key)),
  map(join('=')),
  join('&'),
);
